import { NormalizedOptions, FetchOptions } from '../types';
import { defaultAfterResponse, defaultBeforeRequest } from '../constants';
import { isBrowser } from '../utils';

export function normalizeOptions(
  options: FetchOptions = {}
): NormalizedOptions {
  const fetcher = options.fetcher || (isBrowser() ? window.fetch : undefined);
  if (!fetcher) {
    throw new Error('You need to provide a "fetcher" for server environments');
  }

  // `typeof`: a bare `process` throws where no bundler defines it (Storybook).
  const hasProcess = typeof process !== 'undefined';
  const baseUrl =
    (hasProcess && process.env.ZAPIER_FETCH_BASE_URL) ||
    (hasProcess && process.env.NEXT_PUBLIC_ZAPIER_FETCH_BASE_URL) ||
    options.baseUrl ||
    '';

  return {
    baseUrl,
    fetcher,
    beforeRequest: options.beforeRequest || [...defaultBeforeRequest],
    afterResponse: options.afterResponse || [...defaultAfterResponse],
  };
}
